import { render, staticRenderFns } from "./ChartContactIcon.vue?vue&type=template&id=3b14764c&scoped=true"
import script from "./ChartContactIcon.vue?vue&type=script&lang=ts"
export * from "./ChartContactIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChartContactIcon.vue?vue&type=style&index=0&id=3b14764c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b14764c",
  null
  
)

export default component.exports